import React, { useEffect, useState } from "react";
import { Button, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  DragHandleOutlined,
  VisibilityOutlined,
  DeleteForeverOutlined,
} from "@mui/icons-material";
import SidebarProductsEdit from "./SidebarProductsEdit";
import SidebarSubProducts from "./SidebarSubProducts";
import { useDragDrop } from "../../hooks/useDragDrop";
import useProduct from "../../hooks/useProduct";

export default function ListTableProducts({
  products,
  productsLinea,
  productsEspecial,
  titleProduct,
  handleClickSidebar,
  handleVisibility,
  handleDelete,
}) {

  const { setProducts } = useProduct();
  const [newProdLinea, setNewProdLinea] = useState(productsLinea);
  const [newProdEspecial, setNewProdEspecial] = useState(productsEspecial);
  const { dragStart, dragEnter, drop } = useDragDrop({
    list: products,
    setList:
      productsEspecial?.length > 0
        ? setNewProdLinea
        : productsLinea?.length > 0
        ? setNewProdEspecial
        : [],
  });

  useEffect(() => {
    // Combina los productos de línea y productos especiales en un array único
    if (productsEspecial?.length > 0) {
      const newProducts = newProdLinea?.concat(productsEspecial);
      return setProducts(newProducts);
    }
    if (productsLinea?.length > 0) {
      const newProducts = newProdEspecial?.concat(productsLinea);
      return setProducts(newProducts);
    }
  }, [newProdLinea, newProdEspecial]);

  return (
    <Table responsive className="basePgi__table-list" hover>
      <colgroup>
        <col span="1" className="basePgi__table-col-position" />
        <col span="2" className="basePgi__table-col-max" />
        <col span="3" className="basePgi__table-col-min" />
      </colgroup>
      <tbody>
        {products?.map((product, index) => {
          return (
            <tr
              key={index}
              onDragStart={() => dragStart(index)}
              onDragEnter={() => dragEnter(index)}
              onDragEnd={() => drop("product")}
              onDragOver={(e) => e.preventDefault()}
              draggable
              className="draggable"
            >
              <td className="pgi__table-position-number">
                <Button disabled>
                  <DragHandleOutlined />
                </Button>
                {product.type === "productoLinea" ? <b>PL</b> : <b>PE</b>}
              </td>
              <td></td>
              <td
                onClick={() => {
                  handleClickSidebar(product);
                }}
              >
                {product.type === "productoLinea" ? (
                  <SidebarSubProducts
                    productoPadre={product}
                    idProduct={titleProduct}
                  />
                ) : (
                  product.title
                )}
              </td>
              <td>
                <OverlayTrigger
                  key="1"
                  placement="top"
                  overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                >
                  <Button
                    className={product.visible ? "" : "disabled"}
                    onClick={() => handleVisibility(product)}
                  >
                    <VisibilityOutlined />
                  </Button>
                </OverlayTrigger>
              </td>
              <td>
                <SidebarProductsEdit values={product} isEdit={true} />
              </td>
              <td onClick={() => handleDelete(product._id)}>
                <OverlayTrigger
                  key="1"
                  placement="top"
                  overlay={<Tooltip id="1">Eliminar</Tooltip>}
                >
                  <Button>
                    <DeleteForeverOutlined />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
